import React from 'react';

export const GrayTickIcon = () => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <desc>Created with Sketch.</desc>
    <g
      id="Beta-CAJA--—-EDITS/-HELP/-ERRORS.-LW"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Beta--guided-VD" transform="translate(-193.000000, -130.000000)">
        <g id="Header-">
          <g id="Progress-bar-" transform="translate(0.000000, 68.000000)">
            <g id="Group-2-Copy" transform="translate(176.000000, 62.000000)">
              <g id="plus">
                <g id="done" transform="translate(17.000000, 0.000000)">
                  <g id="Group-3">
                    <circle id="Oval" fill="#FFFFFF" cx="12" cy="12" r="10" />
                    <path
                      d="M12,0 C5.36374948,0 0,5.36374948 0,12 C0,18.6362505 5.36374948,24 12,24 C18.6362505,24 24,18.6362505 24,12 C24,5.36374948 18.6362505,0 12,0 Z M10.3128439,17.4201576 C10.0914199,17.6415816 9.81490391,17.7517489 9.53839347,17.7517489 C9.26188304,17.7517489 8.9853726,17.6415761 8.76394304,17.4201576 L4.45093322,13.1060418 L6.02682151,11.5301535 L9.51140606,15.0697636 L17.4201576,7.16101203 L18.9960459,8.73690032 L10.3128439,17.4201576 Z"
                      id="Shape"
                      fill="#747474"
                      fillRule="nonzero"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
